<template>
  <h2 class="heading">Premia User List</h2>
  <el-table :data="allUsers" stripe="true" height="100%" style="width: 95%; margin:15px auto;" :row-class-name="tableRowClassName">
    <el-table-column prop="loginname" label="Login Name" />
    <el-table-column prop="email" label="Email"  width="300" />
    <el-table-column prop="fullname" label="Full Name"  />
    <el-table-column prop="gender" label="Gender"  />
    <el-table-column prop="status" label="Operation" align="center">
        <template #default="scope">
            <el-icon :size="16" @click="handleLockStatus(scope.row.id, scope.row.status)" :title="scope.row.status=='Locked'?'Unclock':'Lock'" class="op">
                <lock v-if="scope.row.status=='Locked'" color="#880" />
                <unlock v-else />
            </el-icon>
            <el-icon :size="16" @click="deleteUser(scope.row.id)" class="op" title="Delete">
                <delete />
            </el-icon>
            <el-icon :size="16" @click="$router.push('/auth/authorizeByUser?userId=' + scope.row.id)" class="op" title="Authorization">
                <avatar />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>
</template>

<script>
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Lock, Unlock, Delete, Avatar } from '@element-plus/icons-vue'
export default {
    components: {
        Lock, Unlock, Delete, Avatar
    },
    data() {
        return {
            allUsers: [],
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "user";
        this.allUsers = await this.global.getAllUsers();
    },
    methods: {
        async deleteUser(id) {
            ElMessageBox.confirm(
                'Are you sure want to delete this user?',  'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning',
                }
            ).then(async () => {
                let result = await AXIOS("/user/deleteUser", {id: id});
                if (result.success) {
                    let deletedUser = this.allUsers.splice(this.allUsers.findIndex(e => e.id == id), 1);
                    ElMessage({
                        message: 'Deleted user "'+deletedUser[0].loginname+'" successfully!',
                        type: 'success',
                    });
                } else {
                    ElMessage({ message: result.errMsg, type: 'error'});
                }
            })
        },
        tableRowClassName(scope) {
            return (scope.row.status === 'Locked') ? 'warning-row' : '';
        },
        async handleLockStatus(id, status) {
            let newStatus = "Locked"===status ? "OK" : "Locked"
            let data = {id: id, status: newStatus}

            let result = await AXIOS("/user/lockOrUnlockUser", data);
            if (result.success) {
                let user = this.allUsers.find(e => e.id == id);
                user.status = newStatus;
                let action = newStatus==="Locked" ? "Lock" : "Unlock";
                ElMessage({
                    message: action + ' user "'+user.loginname+'" successfully!',
                    type: 'success',
                });
            } else {
                ElMessage({ message: result.errMsg, type: 'error'});
            }
        }
    },
}
</script>

<style>
    .el-table .el-icon {
        margin: 0px 3px; color: #409eff;
    }
    .op {
        color:#01b1af; text-decoration: none; font-weight:bold; vertical-align: middle; cursor: pointer;
    }
    .el-table .warning-row {
        --el-table-tr-bg-color: var(--el-color-warning-lighter);
    }
    .heading {
        text-align:center;
        color:#01b1af;
        font-family: Arial, Helvetica, sans-serif;
    }
</style>